
import auth from "./AuthAPI.js";
import * as APPCONFIG from "../config/app-config.js";
import Http from "./Http.js";

class NotificationApi {


      getNotificationforAdmin(form) {
        return auth({
          method: "post",
          headers: Http.AUTH_HEADERS(),
          url: `${APPCONFIG.API_URL}api/getNotificationforAdmin`,
          data: JSON.stringify(form),
        });
      }

      getNotificationforAdmin(form) {
        return auth({
          method: "post",
          headers: Http.AUTH_HEADERS(),
          url: `${APPCONFIG.API_URL}api/getSafetyNotification`,
          data: JSON.stringify(form),
        });
      }

      

      changeNotificationStatus (form){
        return auth({
          method: "post",
          headers: Http.AUTH_HEADERS(),
          url: `${APPCONFIG.API_URL}api/changeNotificationStatus`,
          data: JSON.stringify(form),
        });
      }


      getAuditTrailData(form) {
        return auth({
          method: "post",
          headers: Http.AUTH_HEADERS(),
          url: `${APPCONFIG.API_URL}api/getAuditTrailData`,
          data: JSON.stringify(form),
        });
      }


}

export default new NotificationApi();